import {FormLabel} from "@/components/form/FormLabel.tsx";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {PhoneInput} from "@/components/phone/PhoneInput.tsx";
import {getFormError} from "@/lib/form/form.utils.ts";
import {getRequiredError} from "@/pages/checks/components/form/constants.ts";
import {FieldProps} from "@/pages/checks/components/form/fields/common.ts";
import {RegisterOptions, useFormContext} from "react-hook-form";
import * as RIP from "react-international-phone";
import styles from "./PhoneField.module.scss";

export interface PhoneFieldProps extends FieldProps, Omit<RIP.PhoneInputProps, "name"> {
  disabled?: boolean;
  hideErrorMessage?: boolean;
}

export const PhoneField = ({
  id,
  name,
  label,
  className,
  tooltip,
  supportLink,
  helpText,
  required,
  disabled = false,
  hideErrorMessage = false,
  ...props
}: PhoneFieldProps) => {
  const {
    setValue,
    watch,
    formState: {errors},
  } = useFormContext();
  const fieldError = getFormError(name, errors);
  const options: RegisterOptions = {};
  if (required) {
    options.required = getRequiredError(name);
  }
  return (
    <div className={className}>
      {label && (
        <FormLabel helpText={tooltip} forId={id || name} required={required}>
          {label}
        </FormLabel>
      )}
      <PhoneInput
        {...props}
        name={name}
        inputProps={{
          id: id || name,
          "aria-invalid": !!fieldError,
        }}
        disabled={disabled}
        value={watch(name) || ""}
        inputClassName={styles.phoneInput}
        onChange={(value, meta) => {
          setValue(name, meta.inputValue.trim().length > 0 ? value : "");
          if (props.onChange) props.onChange(value, meta);
        }}
      />
      <FormSubtext
        subText={helpText}
        supportLink={supportLink}
        error={hideErrorMessage ? "" : fieldError?.toString()}
      />
    </div>
  );
};
